"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeappBridgeMessage = void 0;
/**
 * 事件消息
 */
var WeappBridgeMessage;
(function (WeappBridgeMessage) {
    WeappBridgeMessage["isReady"] = "Are You OK?";
    WeappBridgeMessage["ready"] = "I`m OK!";
    WeappBridgeMessage["ping"] = "ping";
    WeappBridgeMessage["pong"] = "pong";
    WeappBridgeMessage["alive"] = "I`m alive!";
})(WeappBridgeMessage = exports.WeappBridgeMessage || (exports.WeappBridgeMessage = {}));
//# sourceMappingURL=WeappBridgeMessage.js.map